import React, { useEffect, useState } from "react";
import "./style.scss";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import { Link } from "react-router-dom";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import BaseURL from "../../assets/utils/baseUrl";

function Berita({ setToken }) {
  const [informasi, setInformasi] = useState([]);
  const [informasiPerPage, setInformasiPerPage] = useState([]);
  const [pageNumber, setPageNumber] = useState([]);
  const [pageShow, setPageShow] = useState(0);
  const [loading, setLoading] = useState(true);

  const itemPerPageLength = 10;

  useDocumentTitle("Informasi - BAPENDA KOTA BEKASI");

  // ✅ ambil data API
  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const res = await fetch(BaseURL + "index.php/api/Berita?key=bapenda123");

        if (!res.ok) throw new Error("Gagal fetch");

        const data = await res.json();

        const result = Array.isArray(data?.data) ? data.data : [];

        setInformasi(result);
      } catch (err) {
        console.error("ERROR:", err);
        setInformasi([]);
      } finally {
        setLoading(false);
      }
    };

    getData();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // ✅ pagination aman
  useEffect(() => {
    if (!Array.isArray(informasi)) return;

    const totalPage = Math.ceil(informasi.length / itemPerPageLength);
    const pages = Array.from({ length: totalPage }, (_, i) => i);

    setPageNumber(pages);

    const start = pageShow * itemPerPageLength;
    const end = start + itemPerPageLength;

    setInformasiPerPage(informasi.slice(start, end));
  }, [informasi, pageShow]);

  const pageChanger = (item) => {
    setPageShow(item);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="page">
      <Header active="publikasi" />

      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Publikasi / Berita" />

          <div className="page-title-wrapper">
            <div className="page-title">Berita Terkini</div>
          </div>

          <div className="informasi-list-wrapper">
            {/* ✅ loading */}
            {loading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                Loading...
              </div>
            ) : informasiPerPage && informasiPerPage.length > 0 ? (
              informasiPerPage.map((item) => (
                <div className="informasi-list-item" key={item.id_berita}>
                  <div className="informasi-list-thumbnail-wrapper">
                    <img
                      className="informasi-list-thumbnail"
                      src={
                        item?.thumbnail
                          ? BaseURL + "assets/images/berita/" + item.thumbnail
                          : "/no-image.png"
                      }
                      alt={item?.judul || "berita"}
                    />
                  </div>

                  <div className="informasi-list-informasi">
                    <div>
                      <p className="informasi-list-title">
                        {item?.judul || "-"}
                      </p>

                      <p className="informasi-list-date">
                        {item?.created_date || "-"}
                      </p>

                      <p className="informasi-list-desc">
                        {item?.konten
                          ? item.konten
                              .substring(0, 400)
                              .replace("(_newline)", " ")
                          : ""}{" "}
                        [ ... ]
                      </p>
                    </div>

                    <Link to={"/berita-detail/" + (item?.id_berita || "")}>
                      <div className="informasi-list-desc link">
                        Selengkapnya
                      </div>
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", padding: "20px" }}>
                Tidak ada data berita
              </div>
            )}
          </div>

          <div className="pagination-wrapper">
            {(pageNumber || []).map((item, idx) => (
              <div
                key={idx}
                className={
                  item === pageShow
                    ? "page-number page-number-active"
                    : "page-number"
                }
                onClick={() => pageChanger(item)}
              >
                {item + 1}
              </div>
            ))}
          </div>
        </section>

        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Berita;